// this file handles the "below-the-hero" CTA bar which includes
// a "time left to call" timer

// this manages the countdown timer on microsite sticky cta areas
import { addClass, removeClass, getParameterByName } from './_utilities';

// create new date object for declaring other variables
const date = new Date();

// set current month
let month = date.getMonth(); // 0:Jan to 11:Dec

// set current day
let day = date.getDate(); // 1 to 31 (day of month)

// set current day of the week
const weekDay = date.getDay(); // 0:Sun to 6:Sat

// set default start and end hours object for countdown script
const hours = {
    start: new Date(date.getFullYear(), month, day),
    end: new Date(date.getFullYear(), month, day),
};

// element class names
const ctaTimerClass = 'cta__timer';
const ctaTimerClassNew = 'cta-new__timer';
const timerHoursClass = 'timer__hours';
const timerMinutesClass = 'timer__minutes';
const timerSecondsClass = 'timer__seconds';

// areas to hide outside of service hours (timer, MAPI phone areas)
const ctaTimerHideClass = 'cta__timer--is-hidden';
const ctaTimerNewHideClass = 'cta-new__timer--is-hidden';
const ctaCallTextHideClass = 'hide';
const promoCallTextHideClass = 'header__promo__phone--is-hidden';

// bind container elements
let ctaTimer = document.querySelector(`.${ctaTimerClass}`);
if (ctaTimer === null) {
    ctaTimer = document.querySelector(`.${ctaTimerClassNew}`);
}
const ctaCallText = document.querySelector('.cta__call-text');
const promoCallText = document.querySelector('.header__promo__phone');
const navPhone = document.querySelector('.cta-nav__phone');
const callToOrderButton = document.querySelector(
    '.cta-new2__button-call-to-order'
);

// bind elements for displaying time values
const hoursEl = document.querySelector(`.${timerHoursClass}`);
const minutesEl = document.querySelector(`.${timerMinutesClass}`);
const secondsEl = document.querySelector(`.${timerSecondsClass}`);

// initialize countdown timer
const timerInit = () => {
    // create current date object for performing operations
    const now = new Date();

    // calculate countdown hours, minutes and seconds
    const countHours = `0${hours.end.getHours() - now.getHours()}`.substr(-2);
    const countMinutes = `0${59 - now.getMinutes()}`.substr(-2);
    const countSeconds = `0${59 - now.getSeconds()}`.substr(-2);

    // set values for countdown elements
    hoursEl.innerText = countHours;
    minutesEl.innerText = countMinutes;
    secondsEl.innerText = countSeconds;

    // is "now" before business (start) hours? hide areas
    const href = window.location.href;
    if (href.indexOf('xfinity') >= 0) {
        // uses cta_new_timer.tpl
        if (now.getHours() <= hours.start.getHours()) {
            addClass(ctaTimer, ctaTimerNewHideClass);
            addClass(navPhone, 'hide');
            addClass(callToOrderButton, 'hide');
        }

        // is "now" after business (end) hours? hide areas
        if (now.getHours() > hours.end.getHours()) {
            addClass(ctaTimer, ctaTimerNewHideClass);
            addClass(navPhone, 'hide');
            addClass(callToOrderButton, 'hide');
        }
    } else {
        // uses cta_new.php
        if (now.getHours() <= hours.start.getHours()) {
            addClass(ctaTimer, ctaTimerHideClass);
            addClass(ctaCallText, ctaCallTextHideClass);
            addClass(promoCallText, promoCallTextHideClass);
            removeClass(
                document.querySelector('.cta__text1'),
                'show-for-medium'
            );
        }

        // is "now" after business (end) hours? hide areas
        if (now.getHours() > hours.end.getHours()) {
            // /charter?setstart=8&setend=10
            addClass(ctaTimer, ctaTimerHideClass);
            addClass(ctaCallText, ctaCallTextHideClass);
            addClass(promoCallText, promoCallTextHideClass);
            removeClass(
                document.querySelector('.cta__text1'),
                'show-for-medium'
            );
        }
    }
};

// adjust hours based upon brand and/or holiday
/* eslint-disable */
const adjustHours = () => {
    // Bind variable to window location href
    let setStart = 0,
        setEnd = 0;
    const href = window.location.href;

    // Frontier hours
    if (href.indexOf('frontier') >= 0) {
        setStart = 5;
        setEnd = 22;

        if (weekDay === 6) {
            setStart = 7;
            setEnd = 19;
        }

        if (weekDay === 0) {
            setStart = 8;
            setEnd = 17;
        }
        // Dish hours
    } else if (href.indexOf('dish') >= 0) {
        setStart = 6;
        setEnd = 20;

        if (weekDay === 6) {
            setStart = 8;
            setEnd = 19;
        }

        if (weekDay === 0) {
            setStart = 9;
            setEnd = 17;
        }

        // CenturyLink hours
    } else if (href.indexOf('centurylink') >= 0) {
        setStart = 6;
        setEnd = 22;

        if (weekDay === 6) {
            setStart = 8;
            setEnd = 20;
        }

        if (weekDay === 0) {
            setStart = 9;
            setEnd = 18;
        }
    } else {
        // all other hours
        setStart = 1;
        setEnd = 23;
    }

    // set month/day parameters through URL (for testing)
    if (getParameterByName('setmonth', href)) {
        month = parseInt(getParameterByName('setmonth', href));
    }
    if (getParameterByName('setday', href)) {
        day = parseInt(getParameterByName('setday', href));
    }

    // console.log('day:', day);
    // console.log('month:', month);

    // July 4th hours
    if (
        href.indexOf('frontier') >= 0 ||
        href.indexOf('dish') >= 0 ||
        href.indexOf('centurylink') >= 0
    ) {
        if (month === 6 && day === 4) {
            // 6:Jul, 4:4th of July
            setStart = 7;
            setEnd = 16;
        }
    }

    // Thanksgiving 2017
    if (month === 10 && day === 21) {
        // 10:Nov, 21:3rd Thursday
        addClass(ctaTimer, ctaTimerHideClass); // hide timer
    }

    // Christmas Eve/Day
    if (month === 11 && (day === 24 || day === 25)) {
        // 11:Dec, 24-25:Christmas Eve/Day
        addClass(ctaTimer, ctaTimerHideClass); // closed; hide timer
    }

    // Day after Christmas
    if (month === 11 && day === 26) {
        // 11:Dec, 26: Day after Christmas
        setStart = 8; // open later @ 9am
    }

    // New Years Eve
    if (month === 11 && day === 31) {
        // 11:Dec, 31:New Years Eve
        addClass(ctaTimer, ctaTimerHideClass); // closed; hide timer
    }

    // New Years Day
    if (month === 0 && day === 1) {
        // 0:Jan, 1:New Years Day
        setStart = 8; // open later @ 9am
    }

    // set start/end parameters through URL (for testing)
    if (getParameterByName('setstart', href)) {
        setStart = parseInt(getParameterByName('setstart', href));
    }
    if (getParameterByName('setend', href)) {
        setEnd = parseInt(getParameterByName('setend', href));
    }

    // console.log('setStart:', setStart);
    // console.log('setEnd:', setEnd);

    // set according to values assigned to setStart/setEnd
    if (setStart) {
        hours.start.setHours(setStart);
    }

    if (setEnd) {
        hours.end.setHours(setEnd);
    }
};
/* eslint-enable */

// module startup
const init = () => {
    if (ctaTimer !== null) {
        // adjust business hours (when areas are shown) on holidays according to brand
        adjustHours();

        // countdown every second
        setInterval(() => {
            timerInit();
        }, 1000);
    }
};

export { init };
